import React, { FC } from 'react';

//redux
import { useAppSelector } from '../../store/hooks';
import userSelectors from '../../store/user/userSelectors';
import { UserRoleEnum } from '../../store/user/userTypes';

//mui components
import { Menu, MenuItem, Typography } from '@mui/material';

//icons
import LogoutBoxLineIcon from 'remixicon-react/LogoutBoxLineIcon';
import LockPasswordLineIcon from 'remixicon-react/LockPasswordLineIcon';

//styles
import styles from './styles.module.scss';

interface IMenuList {
  text: string;
  icon: React.ReactNode;
}
const menuList: IMenuList[] = [
  {
    text: 'Reset Password',
    icon: <LockPasswordLineIcon />,
  },
  {
    text: 'Log Out',
    icon: <LogoutBoxLineIcon />,
  },
];

interface ProfileMenuProps {
  anchorEl: HTMLElement | null;
  closeMenu: () => void;
  onMenuItemClick: (menuItem: string) => void;
}

const ProfileMenu: FC<ProfileMenuProps> = ({
  anchorEl,
  closeMenu,
  onMenuItemClick,
}) => {
  const currentUser = useAppSelector(userSelectors.getCurrentUser);

  const menuListFiltered = menuList.filter(
    (menuItem) =>
      !(menuItem.text === 'Reset Password' && currentUser.role === UserRoleEnum.SUPER_ADMIN)
  );

  return (
    <Menu
      className={styles.profileMenu}
      anchorEl={anchorEl}
      id="primary-search-account-menu"
      keepMounted
      open={Boolean(anchorEl)}
      onClose={closeMenu}
      disableScrollLock
    >
      {menuListFiltered.map(({ text, icon }, index) => (
        <MenuItem
          key={index}
          onClick={() => onMenuItemClick(text)}
          className={styles.profileMenu}
        >
          {icon}
          <Typography className={styles.menuText} variant="h6">
            {text}
          </Typography>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default ProfileMenu;
